<script lang="ts" setup>
import { useCrystalUrl } from "@/use/common";

const url = useCrystalUrl();
</script>
<template>
  <img :src="url" alt="" class="icon-base" crossorigin="anonymous" />
</template>
